<mat-card appearance="outlined"
  [ngClass]="(deviceLg == true || deviceXl == true) ? 'm-10 m-xl-2 brder-class pd-t-3' : 'mat-card-center brder-class pd-t-3 m-10 m-xl-2'"
  class="task-card-container">
  <div
    class="cardHeader text-center d-flex flex-row align-items-center justify-content-center d-sm-flex flex-sm-row align-items-xl-center justify-content-sm-between d-md-flex flex-md-row align-items-md-center justify-content-md-between d-lg-flex align-items-lg-center flex-lg-row justify-content-lg-between d-xl-flex align-items-xl-center flex-xl-row justify-content-xl-between">
    <div
      class="col-4 d-flex justify-content-start align-items-center col-sm-4 d-sm-flex justify-content-sm-start align-items-sm-center col-md-4 d-md-flex justify-content-md-start align-items-md-center col-lg-4 d-lg-flex justify-content-lg-start align-items-lg-center col-xl-4 d-xl-flex justify-content-xl-start align-items-xl-center">
      <mat-icon class="cardheadIcon dboard-hdr-icon-color ">event_available</mat-icon>
      <h2 class="margin-0 dboard-hdr f-weight">Task</h2>
    </div>
    <div
      class="col-8 d-flex justify-content-end align-items-center col-sm-8 d-sm-flex justify-content-sm-end align-items-sm-center col-md-8 d-md-flex justify-content-md-end align-items-md-center col-lg-8 d-lg-flex justify-content-lg-end align-items-lg-center col-xl-8 d-xl-flex justify-content-xl-end align-items-xl-center">
      <table class="removeBorder">
        <tr>
          <td class="brdr-left-solid removeBorder">
            <div class="" id="date-range-filter" hidden="true">

              <mat-form-field class="date-range"
                [ngStyle]="deviceLg == true || deviceXl == true ? {} : {'width' : '85px'}" floatLabel="always">
                <mat-label>Date range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                  <input readonly (focus)="picker.open()" matInput id="start-date" #start matStartDate
                    placeholder="Start date" [(ngModel)]="startFilterDate">
                  <input readonly (focus)="picker.open()" matInput id="end-date" #end matEndDate placeholder="End date"
                    [(ngModel)]="endFilterDate">
                </mat-date-range-input>
                <mat-datepicker-toggle class="date-toggle-icon-alignment" id="calendar-click-icon-t" matSuffix
                  [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker [formControl]="calendar">
                  <mat-date-range-picker-actions>
                    <button mat-button matDateRangePickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDateRangePickerApply
                      (click)="triggerAlert()">Apply</button>
                  </mat-date-range-picker-actions>
                </mat-date-range-picker>
                <mat-icon *ngIf="isShown" class="search-icon" (click)="triggerRefresh(0)" matSuffix>close</mat-icon>
              </mat-form-field>
            </div>
          </td>
          <td class="removeBorder">
            <div class="pd-l-5" id="search-filter">
              <mat-form-field floatLabel="always"
                [ngStyle]="deviceLg == true || deviceXl == true ? {} : {'width' : '85px'}">
                <input id="task-search-field" matInput placeholder="Search" #input>
                <mat-icon class="search-icon-alignment" matSuffix>search</mat-icon>
                <mat-icon *ngIf="isShown || input.value" class="search-icon" (click)="triggerRefresh(0)"
                  matSuffix>close</mat-icon>
              </mat-form-field>
            </div>
          </td>
          <td class="removeBorder">
            <mat-icon class="filter-dropdown-icon-alignment pointer" [matMenuTriggerFor]="menu">expand_more</mat-icon>
          </td>
          <td class="brdr-left-solid removeBorder">
            <div class="d-flex align-items-center panel-icon-section">
              <span>
                <mat-icon tooltip="Enter Full Screen" triggers="hover" container="body"
                  *ngIf="!sideNavService.returnExpandFullScreeBooleanSetter()"
                  (click)="(deviceLg || deviceXl || deviceMd) ? sideNavService.expandFullScreenBooleanSetter(true,'task-card-container','panel-fullscreen') : sideNavService.expandFullScreenBooleanSetter(true,'task-card-container','panel-fullscreen-mb-view')"
                  (click)="triggerRefresh(1)" class="pointer panel-icn-fold-unfold">fullscreen</mat-icon>
                <mat-icon tooltip="Exit Full Screen" triggers="hover" container="body"
                  *ngIf="sideNavService.returnExpandFullScreeBooleanSetter()"
                  (click)="(deviceLg || deviceXl || deviceMd) ? sideNavService.expandFullScreenBooleanSetter(false,'task-card-container','panel-fullscreen') : sideNavService.expandFullScreenBooleanSetter(false,'task-card-container','panel-fullscreen-mb-view')"
                  (click)="triggerRefresh(1)" class="pointer panel-icn-fold-unfold">fullscreen_exit</mat-icon>
              </span>
            </div>
          </td>
        </tr>
      </table>
      <mat-menu #menu="matMenu" class="filter-drop-down">
        <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize" mat-menu-item
          (click)="toggleFilter('oneWeek')">
          <mat-icon class="mat-icon-menu">date_range</mat-icon>
          <h3 class="mat-menu-content-alignment text-capitalize margin-0">previous week</h3>
        </button>
        <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize" mat-menu-item
          (click)="toggleFilter('twoWeek')">
          <mat-icon class="mat-icon-menu">date_range</mat-icon>
          <h3 class="mat-menu-content-alignment text-capitalize margin-0">next week</h3>
        </button>
        <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize" mat-menu-item
          (click)="toggleFilter('nxtTwoWeek')">
          <mat-icon class="mat-icon-menu">date_range</mat-icon>
          <h3 class="mat-menu-content-alignment text-capitalize margin-0">next two weeks</h3>
        </button>
        <button class="body-font-size d-flex align-items-center menu-btn-alignment text-capitalize" mat-menu-item
          (click)="toggleFilter('dateRange')">
          <mat-icon class="mat-icon-menu">date_range</mat-icon>
          <h3 class="mat-menu-content-alignment text-capitalize margin-0">date range</h3>
        </button>
      </mat-menu>
      <!-- </div> -->
    </div>
  </div>
  <mat-divider></mat-divider>
  <div>
    <div *ngIf="taskDataSource.loading$ | async">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div [ngStyle]="{'position':'absolute', 'right':'18px', 'top':'75px'}" *ngIf="checked">
      <button (click)="updateGroupTask()"
        [ngStyle]="{'background-color':'var(--strt-bttn-bg)', 'color':'var(--bttn-light)', 'padding':'10px', 'height':'31px', 'padding-top':'10px', 'z-index':'100'}"
        mat-raised-button>
        COMPLETE
      </button>
    </div>
    <mat-tab-group mat-align-tabs="start" #tabGroup (selectedTabChange)="tabChanged($event)">
      <mat-tab class="body-font-size" label="My Task">
        <div class="meeting-indicator">
          <mat-progress-spinner mode="indeterminate" [diameter]="20" *ngIf="taskDataSource.loading$ | async"
            bdColor="rgba(51,51,51,0.8)"></mat-progress-spinner>
        </div>
        <ng-scrollbar
          [ngClass]="sideNavService.returnExpandFullScreeBooleanSetter() ? 'panel-fullscreen-card-inner-task' : 'global-container'"
          appearance="compact" #scrollable pointerEventsMethod="scrollbar">
          <!--<mat-table [dataSource]="dateRangeArray.length == 0 ? taskDataSource : dateRangeArray" class="table-mat" >-->
          <mat-table [dataSource]="taskDataSource" class="table-mat">
            <ng-container matColumnDef="dueDate">
              <mat-header-cell *matHeaderCellDef [ngStyle]="{'display':'none'}">Due Date</mat-header-cell>
              <!-- <mat-cell *matCellDef="let task" class="task-met-cell p-lr-20">{{task.actionItemDueDate}}</mat-cell> -->
              <mat-cell *matCellDef="let task" [ngStyle]="{'flex':'none'}"
                [ngStyle]="sideNavService.returnExpandFullScreeBooleanSetter() && (deviceXl || deviceLg) ? {'width' : '185px'} : {}"
                [ngClass]="!sideNavService.returnExpandFullScreeBooleanSetter() ? 'task-met-cell col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 pd-r-10px' : 'task-met-cell col pd-r-10px'">
                <div
                  [ngStyle]="sideNavService.returnExpandFullScreeBooleanSetter() && (deviceXl || deviceLg) ? {'display' : 'contents'} : {}">
                  <h4 class="margin-0 f-weight line-height-1">Due Date</h4>
                  <h4
                    [ngClass]="sideNavService.returnExpandFullScreeBooleanSetter() && (deviceXl || deviceLg) ? 'margin-0 pd-l-5 no-wrap' : 'margin-0 no-wrap'">
                    {{task.actionItemDueDate | date:'mediumDate'}}</h4>
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="taskTitle">
              <mat-header-cell *matHeaderCellDef [ngStyle]="{'display':'none'}">Task Title</mat-header-cell>
              <mat-cell
                [ngClass]="!sideNavService.returnExpandFullScreeBooleanSetter() && (deviceXl || deviceLg) ? 'col-xl-10 col-lg-10 col-md-10 col-sm-10 col-5' : 'col'"
                *matCellDef="let task; let i = index">
                <div [ngStyle]="{'display':'flex'}" class="col-12">
                  <div [ngStyle]="{'margin':'1px 5px 0px 0px'}">
                    <!-- <mat-checkbox class="example-margin checkbox-Task" id = {{i}} (click) = "checkBoxTracker(i)"></mat-checkbox> -->
                    <input [checked]="checkBoxObj.includes(task.taskId)" type="checkbox"
                      [ngStyle]="{'height':'15px', 'width':'15px'}" class="example-margin checkbox-Task" id="{{i}}"
                      (click)="checkBoxTracker(i,task.taskId,$event)" />
                  </div>
                  <div class="col-11"
                    [ngStyle]="sideNavService.returnExpandFullScreeBooleanSetter() ? {'display' : 'contents'} : {}">
                    <div class="d-flex flex-wrap">
                      <div class="task-title-editor-wrapper">
                        <div class="f-weight pointer margin-0 task-title-editor" tooltip="View Task Information" triggers="hover"
                          placement="auto" [ngStyle]="{'position':'relative', 'top':'-3px'}" id="TASK"
                          (click)="loadTaskInfo(task.taskId,task.meetingId)">
                          <app-adc-editor
                            class="task-adc-editor"
                            [readOnly]="true"
                            [content]="task?.actionItemTitle?.toString() || ''"
                            [config]="readOnlyQuillConfig"
                          ></app-adc-editor>
                        </div>
                      </div>
                      <div>
                        <span class="assigned" tooltip="Assigned By" triggers="hover" placement="bottom"><mat-icon
                            class="groupIcon">group</mat-icon></span>
                        <span class="assignedBy">{{task.assignedBy}}</span>
                      </div>
                    </div>
                    <div class="space-between-task-meeting d-flex align-items-center"
                      [ngStyle]="sideNavService.returnExpandFullScreeBooleanSetter() ? {'margin' : '0px 0px 0px 0px'} : {}">
                      <!-- <h4 class="f-weight" [ngStyle]="{'font-size':'13px', 'padding':'2px 0px 0px 0px'}"><a class="pointer" tooltip = "Go To Meeting Page" triggers = "hover" placement = "left" (click)="redirectToMeeting(task.meetingId)" id="TASK-MeetingTitle" [ngStyle]="{'font-size':'0.8rem', 'text-decoration':'underline'}">{{task.meetingTitle}}</a></h3> -->
                      <a class="pointer" tooltip="Go To Meeting Page" triggers="hover" placement='right'
                        (click)="redirectToMeeting(task)" id="TASK-MeetingTitle"
                        [ngStyle]="{'text-decoration':'underline', 'padding':'2px 0px 0px 0px'}">{{task.meetingTitle}}</a>
                    </div>
                    <!-- <h2 class="m-b-6 f-weight" [ngStyle]="{'font-size':'12px', 'line-height':'initial'}"><span class="italic" [ngStyle]="{'font-size':'12px'}">Assigned By: </span>{{task.assignedBy}}</h2> -->
                  </div>
                </div>

              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="responsivetaskTitle">
              <mat-header-cell *matHeaderCellDef [ngStyle]="{'display':'none'}">Task Title</mat-header-cell>
              <mat-cell class="col-sm-9 col-xs-9 col-md-8" *matCellDef="let task; let i = index">
                <div [ngStyle]="{'display':'flex'}">
                  <div [ngStyle]="{'margin':'5px 5px 0px 0px'}">
                    <!-- <mat-checkbox class="example-margin checkbox-Task" id = {{i}} (click) = "checkBoxTracker(i)"></mat-checkbox> -->
                    <input [checked]="checkBoxObj.includes(task.taskId)" type="checkbox"
                      [ngStyle]="{'height':'15px', 'width':'15px'}" class="example-margin checkbox-Task" id="{{i}}"
                      (click)="checkBoxTracker(i,task.taskId,$event)" />
                  </div>
                  <div>
                    <div class="margin-0 task-title-editor-wrapper" [ngStyle]="{'font-size':'14px', 'line-height':'initial'}"
                      (click)="loadTaskInfo(task.taskId,task.meetingId)">
                      <a class="body-font-size pointer task-adc-editor" id="TASK">
                        <app-adc-editor
                          [readOnly]="true"
                          [content]="task?.actionItemTitle?.toString() || ''"
                          [config]="readOnlyQuillConfig"
                        ></app-adc-editor>
                      </a>
                    </div>
                    <h3 class="margin-0" [ngStyle]="{'font-size':'13px', 'line-height':'initial'}"><a
                        (click)="redirectToMeeting(task)">{{task.meetingTitle}}</a></h3>
                    <h2 class="margin-0" [ngStyle]="{'font-size':'13px', 'line-height':'initial'}"><span class="italic">Assigned By:
                      </span>{{task.assignedBy}}</h2>
                  </div>
                </div>

              </mat-cell>
            </ng-container>

            <ng-container>
            </ng-container>
            <ng-container matColumnDef="taskId">
              <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
              <mat-cell *matCellDef="let task">{{task.taskId}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="getdetails">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 justify-content-end"
                [ngStyle]="task.taskId ? {display: 'none'} : {}" *matCellDef="let task">

              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="menu">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell class="col-sm-1 col-xs-1 col-md-1 justify-content-end" *matCellDef="let task">
                <mat-menu #menu="matMenu">
                </mat-menu>

              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
            <tr class="matRow" *matNoDataRow>
              <td class="matCell removeBorder" colspan="4">No data matching the filter</td>
            </tr>
          </mat-table>
        </ng-scrollbar>
      </mat-tab>
      <mat-tab label="All Task" class="body-font-size">
        <div class="meeting-indicator">
          <mat-progress-spinner mode="indeterminate" [diameter]="20" *ngIf="taskDataSource.loading$ | async"
            bdColor="rgba(51,51,51,0.8)"></mat-progress-spinner>
        </div>
        <ng-scrollbar
          [ngClass]="sideNavService.returnExpandFullScreeBooleanSetter() ? 'panel-fullscreen-card-inner-task' : 'global-container'"
          appearance="compact" #scrollable pointerEventsMethod="scrollbar">
          <mat-table [dataSource]="taskDataSource" class="table-mat">

            <ng-container matColumnDef="dueDate">
              <mat-header-cell *matHeaderCellDef [ngStyle]="{'display':'none'}">Due Date</mat-header-cell>
              <mat-cell *matCellDef="let task" [ngStyle]="{'flex':'none'}"
                [ngStyle]="sideNavService.returnExpandFullScreeBooleanSetter() && (deviceXl || deviceLg) ? {'width' : '185px'} : {}"
                [ngClass]="!sideNavService.returnExpandFullScreeBooleanSetter() ? 'task-met-cell col-4 col-sm-2 col-md-2 col-lg-2 col-xl-2 pd-r-10px' : 'task-met-cell col pd-r-10px'">
                <div [ngStyle]="sideNavService.returnExpandFullScreeBooleanSetter() ? {'display' : 'contents'} : {}">
                  <h4 class="margin-0 f-weight line-height-1">Due Date</h4>
                  <h4
                    [ngClass]="sideNavService.returnExpandFullScreeBooleanSetter() && (deviceXl || deviceLg) ? 'margin-0 pd-l-5' : 'margin-0'">
                    {{task.actionItemDueDate | date:'mediumDate'}}</h4>
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="taskTitle">
              <mat-header-cell *matHeaderCellDef [ngStyle]="{'display':'none'}">Task Title</mat-header-cell>
              <mat-cell
                [ngClass]="!sideNavService.returnExpandFullScreeBooleanSetter() ? 'col-xl-10 col-lg-10 col-md-10 col-sm-10 col-5' : 'col'"
                *matCellDef="let task; let i = index">
                <div class="col-11"
                  [ngStyle]="sideNavService.returnExpandFullScreeBooleanSetter() ? {'display' : 'contents'} : {}">
                  <div class="d-flex flex-wrap">
                    <div class="task-title-editor-wrapper">
                      <div class="f-weight pointer margin-0 task-title-editor" [ngStyle]="{'position':'relative', 'top':'-3px'}" id="TASK"
                        (click)="loadTaskInfo(task.taskId,task.meetingId)" tooltip="View Task Information"
                        triggers="hover" placement="left">
                        <app-adc-editor
                          class="task-adc-editor"
                          [readOnly]="true"
                          [content]="task?.actionItemTitle?.toString() || ''"
                          [config]="readOnlyQuillConfig"
                        ></app-adc-editor>
                      </div>
                    </div>
                    <div>
                      <span class="assigned" tooltip="Assigned To" triggers="hover" placement="bottom"><mat-icon
                          class="groupIcon">group</mat-icon></span>
                      <span class="assignedBy">{{task.ownerNames}}</span>
                    </div>
                    <!-- <h2 class="m-b-6 f-weight" [ngStyle]="{'font-size':'12px', 'line-height':'initial'}"><span class="italic" [ngStyle]="{'font-size':'12px'}">Assigned To: </span>{{task.ownerNames}}</h2> -->
                  </div>
                  <div class="space-between-task-meeting d-flex align-items-center">
                    <!-- <h3 id="TASK-MeetingTitle" class="f-weight" [ngStyle]="{'font-size':'13px'}" tooltip = "Go To Meeting Page" triggers = "hover" placement = "left"> -->
                    <a id="TASK-MeetingTitle" class="pointer" [ngStyle]="{'text-decoration':'underline'}"
                      tooltip="Go To Meeting Page" triggers="hover" placement="right"
                      (click)="redirectToMeeting(task)">{{task.meetingTitle}}</a>
                    <!-- </h3> -->
                  </div>
                </div>

              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="responsivetaskTitle">
              <mat-header-cell *matHeaderCellDef [ngStyle]="{'display':'none'}">Task Title</mat-header-cell>
              <mat-cell class="col-sm-9 col-xs-9 col-md-8" *matCellDef="let task; let i = index">
                <div [ngStyle]="{'display':'flex'}">
                  <div>
                    <div class="margin-0 task-title-editor-wrapper" (click)="loadTaskInfo(task.taskId,task.meetingId)" tooltip="Task information"
                      triggers="hover" placement="left">
                      <a class="body-font-size pointer task-adc-editor" id="TASK">
                        <app-adc-editor
                          [readOnly]="true"
                          [content]="task?.actionItemTitle?.toString() || ''"
                          [config]="readOnlyQuillConfig"
                        ></app-adc-editor>
                      </a>
                    </div>
                    <h3 class="margin-0" tooltip="View meeting" triggers="hover" placement="auto"><a
                        (click)="redirectToMeeting(task)">{{task.meetingTitle}}</a></h3>
                    <h2 class="margin-0"><span class="italic">Assigned By: </span>{{task.assignedBy}}</h2>
                  </div>
                </div>

              </mat-cell>
            </ng-container>

            <ng-container>
            </ng-container>
            <ng-container matColumnDef="taskId">
              <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
              <mat-cell *matCellDef="let task">{{task.taskId}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="getdetails">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 justify-content-end"
                [ngStyle]="task.taskId ? {display: 'none'} : {}" *matCellDef="let task">


              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="menu">
              <mat-header-cell *matHeaderCellDef></mat-header-cell>
              <mat-cell class="col-sm-1 col-xs-1 col-md-1 justify-content-end" *matCellDef="let task">


              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
            <tr class="matRow" *matNoDataRow>
              <td class="matCell removeBorder" colspan="4" *ngIf="this.taskDataSource.totalCount=== 0">No data matching
                the filter</td>
            </tr>
          </mat-table>
        </ng-scrollbar>
      </mat-tab>

    </mat-tab-group>


  </div>
  <!-- <mat-divider></mat-divider> -->
  <div class="footer-container">
    <mat-paginator [ngStyle]="{'height':'35px !important'}" [pageSizeOptions]="[10,25,50,75,100]"
      [pageSize]="(sideNavService.returnExpandFullScreeBooleanSetter() && deviceXl) ? 20 : (sideNavService.returnExpandFullScreeBooleanSetter() && deviceLg) ? 20 : 10"></mat-paginator>
  </div>
</mat-card>